import angular from 'angular';
import $ from 'jquery';

export default class UserFaqs {
  constructor($scope, UserService) {
    $scope.set_selected_tab = function(index) {
      $scope.loading = true;
      $scope.selected_tab = index;
      var section_id = $scope.tabs[index].id;
      UserService.get_faqs($scope.user_id, section_id).then(function(data) {
        $scope.loading = false;
        $scope.faqs = data.faqs;
        $scope.apply_filter();
        $scope.set_select_all();
      });
    };

    $scope.faq_filters = [
      {
        id: 'All',
        title: 'All'
      },
      {
        id: '1',
        title: 'Selected'
      },
      {
        id: '0',
        title: 'Not Selected'
      }
    ];

    $scope.$watch('faq_filter', function() {
      $scope.apply_filter();
    });

    $scope.apply_filter = function() {
      angular.forEach($scope.faqs, function(faq) {
        if ($scope.faq_filter == 'All')
          faq.show = true;
        else
          faq.show = ($scope.faq_filter == faq.is_selected);
      });
    };

    $scope.set_select_all = function() {
      var selected_count = 0;
      angular.forEach($scope.faqs, function(faq) {
        if (parseInt(faq.is_selected) == 1)
          selected_count++;
      });
      if (selected_count > 0 && selected_count == $scope.faqs.length)
        $scope.tabs[$scope.selected_tab].select_all = '1';
      else
        $scope.tabs[$scope.selected_tab].select_all = '0';
    };

    $scope.open_dialog = function(dialog_id) {
      window.openFancyboxDialog('div#' + dialog_id);
    };

    $scope.edit_user_faq = function(faq) {
      $scope.dialog_faq = faq;
      $scope.open_dialog('user_faq_dialog');
    };

    $scope.save_user_faq = function() {
      $scope.updating = true;
      UserService.save_faq($scope.user_id, $scope.dialog_faq).then(function(data) {
        if (data.success) {
          $scope.updating = false;
          $.fancybox.close();
          $scope.set_selected_tab($scope.selected_tab);
        }
      });
    };

    $scope.set_faq_state = function(faq) {
      faq.updating = true;
      UserService.save_faq($scope.user_id, faq).then(function(data) {
        if (data.success) {
          faq.updating = false;
          $scope.set_select_all();
          if (parseInt(faq.is_selected) == 0)
            faq.custom_answer = null;
        }
      });
    };

    $scope.set_faq_mass_state = function(select_all) {
      var faqs = [];
      angular.forEach($scope.faqs, function(faq) {
        if (select_all != faq.is_selected)
          faqs.push(faq.id);
      });
      if (faqs.length > 0) {
        $scope.mass_updating = true;
        UserService.mass_save_faqs($scope.user_id, faqs, select_all).then(function(data) {
          if (data.success) {
            $scope.mass_updating = false;
            $scope.set_selected_tab($scope.selected_tab);
          }
        });
      }
    };

    $scope.init = function() {
      $scope.user_id = window.user_id;
      $scope.faq_sections = window.faq_sections;
      $scope.tabs = [{
        id: 0,
        title: 'All',
        select_all: '0'
      }];
      angular.forEach($scope.faq_sections, function(section) {
        $scope.tabs.push({
          id: section.id,
          title: section.title,
          select_all: '0'
        });
      });
      $scope.dialog_faq = null;
      $scope.faq_filter = 'All';
      $scope.set_selected_tab(0);
    };

    $scope.init();
  }
}

UserFaqs.$inject = ['$scope', 'UserService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-faqs.ctrl.js